export const environment = {
  production: false,
  BB_TICKET_SERVICE_URL: "https://uat.apigatewayd.eurofinsgenomics.eu/uat-bbticket/",
  BB_MDMSERVICE_URL: "https://uat.apigatewayd.eurofinsgenomics.eu/uat-bbmdm-ngs/",
  BB_APIGATEWAY_SERVICE_URL: "https://uat.apigatewayd.eurofinsgenomics.eu/uat-bbgateway-ngs/",
  BB_APG_SAMPLE_PROCESSING_URL: "https://uat.apigatewayd.eurofinsgenomics.eu/uat-bbapgngssampleprocesing-ngs/",
  BB_APG_NC_HANDLING_URL: "https://uat.apigatewayd.eurofinsgenomics.eu/api/bbapgngsnchandling/",
  BB_SAMPLE_RECEPTION_SERVICE_URL: "https://uat.apigatewayd.eurofinsgenomics.eu/uat-bbngssamplereception-ngs/",
  BB_PRINT_SERVICE_URL: "https://uat.apigatewayd.eurofinsgenomics.eu/uat-bbprint-sanger/",
  BB_QC_SAMPLE_SERVICE_URL: "",
  BB_SWAB_SAMPLE_RECEPTION_SERVICE_URL: "",
  BB_MARVELMESSAGING_SERVICE_URL: "",
  BB_ORDERRECEPTION_SERVICE_URL: "",
  BB_DMS_SERVICE_URL: "",
  BB_SEQUENCING_SERVICE_URL: "",
  BB_SHIPMENT_SERVICE_URL: "",
  BB_ORDER_CREATION_SCHEDULER_URL: "",
  BB_MAIL_RECEPTION_URL: "",
  BB_NGS_ENTRY_QC_URL: "https://uat.apigatewayd.eurofinsgenomics.eu/uat-bbentryqc-ngs/",
  BB_NGS_LIB_PREP_URL: "https://uat.apigatewayd.eurofinsgenomics.eu/uat-bbngslibrarypreparation-ngs/",
  BB_QC_REPORT_MANAGEMENT_URL: "",
  BB_STORAGE_URL: "https://uat.apigatewayd.eurofinsgenomics.eu/uat-bbstorage/",
  BB_NON_PREMIX_DATA_DELIVERY: '',
  BB_NGS_RUN_PLANNING_URL: "https://uat.apigatewayd.eurofinsgenomics.eu/uat-bbngsrunplanning-ngs/",
  AZURE_AUTHORIZATION_URL: "https://login.microsoftonline.com/1fbb4ba6-ea05-4146-a51e-8eab1e5605f0/oauth2/v2.0/authorize",
  AZURE_TOKEN_URL: "https://login.microsoftonline.com/1fbb4ba6-ea05-4146-a51e-8eab1e5605f0/oauth2/v2.0/token",
  AZURE_LOGOUT_URL: "https://login.microsoftonline.com/1fbb4ba6-ea05-4146-a51e-8eab1e5605f0/oauth2/v2.0/logout",
  AZURE_TENANT_ID: "1fbb4ba6-ea05-4146-a51e-8eab1e5605f0",
  AZURE_BBUI_CLIENT_ID: "428ca4cf-9606-4a86-92ed-b5fb6de2dc0f",
  AZURE_BBUI_REDIRECT_URL_AFTER_LOGIN: "https://ngs-uat.eurofinsgenomics.eu/",
  AZURE_MDM_GROUP_ID: 'BlueberryAdmin',
  AZURE_SANGER_GROUP_CLAIM: 'MDM-ADMIN-GROUP',
  AZURE_APG_GROUP_CLAIM: 'APG-LAB-GROUP',
  AZURE_GenoTyping_Aarhus_GROUP_CLAIM: 'BlueberryGenoTypingAarhusLabUsers',
  AZURE_NGS_Konstanz_GROUP_CLAIM: 'BlueberryNGSKonstanzLabUsers',
  AZURE_APG_Ebersberg_GROUP_CLAIM: 'BlueberryAPGEbersbergLabUsers',
  AZURE_Sanger_Cologne_CLAIM: 'BlueberrySangerCologneLabUsers',
  AZURE_Sanger_Ebersberg_CLAIM: 'BlueberrySangerEbersbergLabUsers',
  AZURE_APG_Denmark_GROUP_CLAIM: 'BlueberryAPGDenmarkLabUsers',
  AZURE_APG_Training_GROUP_CLAIM:'BlueberryAPGTrainingLabUsers',
  AZURE_APG_NETHERLANDS_GROUP_CLAIM: 'BlueberryAPGNederlandLabUsers',
  AZURE_APG_CPH_PCR_GROUP_CLAIM: 'BlueberryAPGCopenhagenLabUsers',
  AZURE_APG_COLOGNE_GROUP_CLAIM: 'BlueberryAPGCologeneLabUsers',
  AZURE_APG_SWEDEN_GROUP_CLAIM:'BlueberryAPGSwedenUppsalaLabUsers',
  AZURE_NGS_KONSTANZ_GROUP_CLAIM: 'BlueberryAPGNGSKonstanzLabUsers',
  AZURE_UK_DTC_POPGEN_LAB_USER_CLAIM : 'UKDTCPopGenLabUsers',
  AZURE_UK_DTC_POPGEN_INVOICING_USER_CLAIM : 'UKDTCPopGenInvoicingUsers',
  AZURE_UK_DTC_POPGEN_LAB_ADMIN_CLAIM : 'UKDTCPopGenLabAdmins',
  AZURE_UK_DTC_POPGEN_BATCH_ACTION_USER_CLAIM : 'UKDTCPopGenBatchActionUsers',
  AZURE_AUTHORIZATION_SCOPE: "api://333a4817-5e18-440a-b5ed-45637283e99c/ngs.access",
  AZURE_LOGIN_NEEDED: true,
  AZURE_APPINSIGHTS_INSTRUMENTATIONKEY: "16cfd254-95f8-47e6-a378-9e4795b770e5",
  BB_ANIMAL_ORDER_SERVICE_URL: "https://uat.apigateway.eurofinsgenomics.eu/uat-bbanimal-orderservice/",
  BB_LAB_MEASUREMENT_URL: "https://uat.apigatewayd.eurofinsgenomics.eu/uat-bblabmeasurement-ngs/",
  //This is the timeout used by frontEnd services.This is in milli seconds.
  defaultTimeout:11000
};
